/* ==========================================================================
   סינון, מיון וטעינה בעמוד קטגוריה — מול נתוני הקטגוריה החיים (?view=nm-index).
   אפשרויות הסינון (מדרגות מידה, טווחי מחיר, מותגים) נגזרות מהמוצרים עצמם.
   ========================================================================== */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CFG = window.NM_COLLECTION;
  if (!CFG || !window.NM) return;

  var PAGE = 24;
  var grid = $('#grid'), emptyState = $('#emptyState'), loadWrap = $('#loadMoreWrap');
  var visCount = $('#visCount'), chipsBox = $('#activeChips'), clearBtn = $('#clearAll');
  var shown = PAGE, all = [], view = [];
  var CHEV = '<svg class="chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';

  function blank() { return { sub: [], w: [], d: [], h: [], price: [], brand: [], sale: false, hasdim: false }; }
  var F = blank();
  var sortMode = 'rec';

  function readURL() {
    var q = new URLSearchParams(location.search);
    ['sub', 'w', 'd', 'h', 'price', 'brand'].forEach(function (k) { var v = q.get(k); if (v) F[k] = v.split(','); });
    if (q.get('sale')) F.sale = true;
    if (q.get('hasdim')) F.hasdim = true;
    if (q.get('sort')) sortMode = q.get('sort');
  }
  function writeURL() {
    var q = new URLSearchParams();
    ['sub', 'w', 'd', 'h', 'price', 'brand'].forEach(function (k) { if (F[k].length) q.set(k, F[k].join(',')); });
    if (F.sale) q.set('sale', '1');
    if (F.hasdim) q.set('hasdim', '1');
    if (sortMode !== 'rec') q.set('sort', sortMode);
    var s = q.toString();
    history.replaceState(null, '', location.pathname + (s ? '?' + s : ''));
  }

  var KEY = { w: 'w', d: 'd', h: 'hh' };
  function inBucket(v, bucket) { return typeof v === 'number' && Math.round(v / 10) * 10 === +bucket; }
  function match(p) {
    if (F.sub.length && F.sub.indexOf(p.s) < 0) return false;
    if (F.w.length && !F.w.some(function (b) { return inBucket(p.w, b); })) return false;
    if (F.d.length && !F.d.some(function (b) { return inBucket(p.d, b); })) return false;
    if (F.h.length && !F.h.some(function (b) { return inBucket(p.hh, b); })) return false;
    if (F.brand.length && F.brand.indexOf(p.b) < 0) return false;
    if (F.sale && !p.cp) return false;
    if (F.hasdim && !(p.w && p.d)) return false;
    if (F.price.length) {
      var ok = F.price.some(function (band) {
        var a = band.split('-'), lo = +a[0], hi = a[1] === '' ? Infinity : +a[1];
        return p.p >= lo && p.p < hi;
      });
      if (!ok) return false;
    }
    return true;
  }
  /* סוג המוצר מתוך השם ("כירת אינדוקציה", "סיר אלומיניום") — כדי שבמיון ברירת המחדל כל סוג יופיע ברצף
     ולא מעורבב: לפי סדר תתי-הקטגוריות, הסוג הנפוץ קודם, חבילות בסוף, ובתוך סוג מהזול ליקר. */
  function typeKey(n) {
    var w = String(n || '').replace(/["'״׳“”’()]/g, '').replace(/פלאנצ/g, 'פלנצ').replace(/אלומניום/g, 'אלומיניום')
      .replace(/^גסט מלמין/, 'גסטרונום').trim().split(/\s+/);
    return w[1] && !/\d/.test(w[1]) ? w[0] + ' ' + w[1] : w[0];
  }
  function recSort(s) {
    var subOrder = {}, freq = {};
    (CFG.subs || []).forEach(function (x, i) { subOrder[x.h] = i; });
    s.forEach(function (p) { p._k = typeKey(p.n); var f = (p.s || '') + '|' + p._k; freq[f] = (freq[f] || 0) + 1; });
    var so = function (p) { return p.s in subOrder ? subOrder[p.s] : 999; };
    var pack = function (p) { return /^(חבילת|שלישייה)/.test(p.n) ? 1 : 0; };
    return s.sort(function (a, b) {
      return so(a) - so(b) || pack(a) - pack(b) ||
        freq[(b.s || '') + '|' + b._k] - freq[(a.s || '') + '|' + a._k] ||
        (a._k < b._k ? -1 : a._k > b._k ? 1 : 0) || a.p - b.p;
    });
  }
  function sortView(arr) {
    var s = arr.slice();
    if (sortMode === 'rec') recSort(s);
    else if (sortMode === 'pa') s.sort(function (a, b) { return a.p - b.p; });
    else if (sortMode === 'pd') s.sort(function (a, b) { return b.p - a.p; });
    else if (sortMode === 'new') s.sort(function (a, b) { return (b.t || 0) - (a.t || 0); });
    return s;
  }

  /* ---------- בניית אפשרויות הסינון מהנתונים ---------- */
  function buckets(key) {
    var vals = all.map(function (p) { return p[key]; }).filter(function (v) { return typeof v === 'number'; });
    if (vals.length < 6) return [];
    var m = {};
    vals.forEach(function (v) { var b = Math.round(v / 10) * 10; m[b] = (m[b] || 0) + 1; });
    return Object.keys(m).map(Number).filter(function (b) { return m[b] >= 2; })
      .sort(function (a, b) { return a - b; }).slice(0, 12).map(function (b) { return [b, m[b]]; });
  }
  function bands() {
    return [[50, 200, '₪50–200'], [200, 500, '₪200–500'], [500, 1000, '₪500–1,000'], [1000, 2500, '₪1,000–2,500'], [2500, 6000, '₪2,500–6,000'], [6000, Infinity, '₪6,000+']]
      .map(function (b) { return { lo: b[0], hi: b[1], label: b[2], n: all.filter(function (p) { return p.p >= b[0] && p.p < b[1]; }).length }; })
      .filter(function (b) { return b.n > 0; });
  }
  function group(pref, id, label, body, open) {
    return '<div class="fgrp"><button class="fgrp__h" type="button" aria-expanded="' + open + '" aria-controls="' + pref + id + '">' + label + CHEV + '</button>' +
      '<div class="fgrp__b" id="' + pref + id + '"' + (open ? '' : ' hidden') + '>' + body + '</div></div>';
  }
  function opt(k, v, label, n) {
    return '<label class="fopt"><input type="checkbox" data-f="' + k + '" value="' + NM.esc(v) + '"><span>' + NM.esc(label) + '</span>' + (n != null ? '<span class="n">' + n + '</span>' : '') + '</label>';
  }
  function buildFilters(pref) {
    var out = '';
    var subs = (CFG.subs || []).map(function (s) {
      return { h: s.h, t: s.t, n: all.filter(function (p) { return p.s === s.h; }).length };
    }).filter(function (s) { return s.n > 0; });
    if (subs.length > 1) out += group(pref, 'sub', 'קטגוריה', subs.map(function (s) { return opt('sub', s.h, s.t, s.n); }).join(''), true);
    [['w', 'רוחב (ס״מ)', true], ['d', 'עומק (ס״מ)', true], ['h', 'גובה (ס״מ)', false]].forEach(function (x) {
      var bk = buckets(KEY[x[0]]);
      if (!bk.length) return;
      out += group(pref, x[0], x[1], '<div class="fdims">' + bk.map(function (b) {
        return '<button class="fdim" type="button" data-f="' + x[0] + '" data-v="' + b[0] + '" title="' + b[1] + ' מוצרים">' + b[0] + '</button>';
      }).join('') + '</div>', x[2]);
    });
    var bd = bands();
    if (bd.length > 1) out += group(pref, 'price', 'מחיר', bd.map(function (b) { return opt('price', b.lo + '-' + (b.hi === Infinity ? '' : b.hi), b.label, b.n); }).join(''), true);
    var brands = {};
    all.forEach(function (p) { if (p.b) brands[p.b] = (brands[p.b] || 0) + 1; });
    var bl = Object.keys(brands).sort(function (a, b) { return brands[b] - brands[a]; });
    if (bl.length) out += group(pref, 'brand', 'מותג', bl.map(function (b) { return opt('brand', b, b, brands[b]); }).join(''), false);
    out += group(pref, 'misc', 'נוסף', opt('sale', '1', 'במבצע') + opt('hasdim', '1', 'עם מידות מלאות'), false);
    return out;
  }
  function paintFilters() {
    $$('[data-fbody]').forEach(function (el, i) { el.innerHTML = buildFilters('f' + i + '-'); });
  }

  /* ---------- רינדור ---------- */
  function render(reset) {
    if (reset) shown = PAGE;
    view = sortView(all.filter(match));
    if (visCount) visCount.textContent = view.length;
    grid.innerHTML = view.slice(0, shown).map(NM.cardHTML).join('');
    grid.hidden = view.length === 0;
    if (emptyState) emptyState.hidden = view.length !== 0;
    if (loadWrap) loadWrap.hidden = view.length <= shown;
    var fm = $('#fmobCount'); if (fm) fm.textContent = view.length;
    var pg = $('.nm-pag'); if (pg) pg.hidden = true;
    paintChips();
    writeURL();
  }

  var LABEL = { w: 'רוחב', d: 'עומק', h: 'גובה' };
  function subTitle(h) { var s = (CFG.subs || []).filter(function (x) { return x.h === h; })[0]; return s ? s.t : h; }
  function paintChips() {
    var chips = [];
    F.sub.forEach(function (v) { chips.push(['sub', v, subTitle(v)]); });
    ['w', 'd', 'h'].forEach(function (k) { F[k].forEach(function (v) { chips.push([k, v, LABEL[k] + ' ' + v + ' ס״מ']); }); });
    F.price.forEach(function (v) {
      var a = v.split('-');
      chips.push(['price', v, '₪' + (+a[0]).toLocaleString('he-IL') + (a[1] ? '–₪' + (+a[1]).toLocaleString('he-IL') : '+')]);
    });
    F.brand.forEach(function (v) { chips.push(['brand', v, v]); });
    if (F.sale) chips.push(['sale', '1', 'במבצע']);
    if (F.hasdim) chips.push(['hasdim', '1', 'עם מידות מלאות']);
    if (chipsBox) chipsBox.innerHTML = chips.map(function (c) {
      return '<span class="fchip">' + NM.esc(c[2]) + '<button type="button" data-rm-k="' + c[0] + '" data-rm-v="' + NM.esc(c[1]) + '" aria-label="הסרת הסינון">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M6 6l12 12M18 6L6 18"/></svg></button></span>';
    }).join('');
    if (clearBtn) clearBtn.hidden = chips.length === 0;
    var n = $('#fmobN'); if (n) { n.textContent = chips.length; n.hidden = chips.length === 0; }
  }
  function syncControls() {
    $$('.fopt input').forEach(function (i) {
      var k = i.getAttribute('data-f');
      i.checked = (k === 'sale' || k === 'hasdim') ? !!F[k] : F[k].indexOf(i.value) > -1;
    });
    $$('.fdim').forEach(function (b) { b.classList.toggle('is-on', F[b.getAttribute('data-f')].indexOf(b.getAttribute('data-v')) > -1); });
  }
  function toggle(k, v) {
    if (k === 'sale' || k === 'hasdim') { F[k] = !F[k]; return; }
    var i = F[k].indexOf(v);
    if (i > -1) F[k].splice(i, 1); else F[k].push(v);
  }

  if (chipsBox) chipsBox.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rm-k]'); if (!b) return;
    var k = b.getAttribute('data-rm-k'), v = b.getAttribute('data-rm-v');
    if (k === 'sale' || k === 'hasdim') F[k] = false; else F[k] = F[k].filter(function (x) { return x !== v; });
    syncControls(); render(true);
  });
  if (clearBtn) clearBtn.addEventListener('click', function () { F = blank(); syncControls(); render(true); });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('.fopt input'); if (!i) return;
    toggle(i.getAttribute('data-f'), i.value); syncControls(); render(true);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.fdim');
    if (b) { toggle(b.getAttribute('data-f'), b.getAttribute('data-v')); syncControls(); render(true); return; }
    var h = e.target.closest('.fgrp__h');
    if (h) {
      var open = h.getAttribute('aria-expanded') === 'true';
      h.setAttribute('aria-expanded', String(!open));
      var body = document.getElementById(h.getAttribute('aria-controls'));
      if (body) body.hidden = open;
    }
  });

  var sortSel = $('#sortSel');
  if (sortSel) sortSel.addEventListener('change', function () { sortMode = sortSel.value; render(true); });
  var more = $('#loadMore');
  if (more) more.addEventListener('click', function () { shown += PAGE; render(false); });

  /* ---------- מגירת סינון במובייל ---------- */
  (function () {
    var btn = $('#fmobBtn'), dr = $('#filterDrawer');
    if (!btn || !dr) return;
    btn.addEventListener('click', function () { NM.openLayer(dr); });
    $$('[data-close-filter]', dr).forEach(function (x) { x.addEventListener('click', NM.closeTop); });
    var apply = $('#fmobApply'); if (apply) apply.addEventListener('click', NM.closeTop);
    var clr = $('#fmobClear'); if (clr) clr.addEventListener('click', function () { F = blank(); syncControls(); render(true); });
  })();

  /* ---------- אתחול ---------- */
  readURL();
  NM.loadCollection(CFG.url)
    .then(function (list) {
      all = list;
      paintFilters();
      if (sortSel) sortSel.value = sortMode;
      syncControls();
      render(true);
    })
    .catch(function () {
      // התצוגה לא נטענה — נשארים עם הגריד שרונדר בשרת והעימוד הרגיל
      $$('[data-fbody]').forEach(function (el) { el.innerHTML = ''; });
    });
})();
